import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Konva from 'konva';
import VueKonva from 'vue-konva';
import utils from './utils';
import API from './API';

// set the site pages Title
document.title = `Trim Designer v${store.state.appVersion}`;

// by default Konva prevent some events when node is dragging
// it improve the performance and work well for 95% of cases
// we need to enable all events on Konva, even when we are dragging a node
// so it triggers touchmove correctly
Konva.hitOnDragEnabled = true;


// do base initialize data into storage before run the App
store.dispatch('baseInitialize')
    .then(() => {
        // App initialized successfully with valid authentication
        const app = createApp(App);

        app.use(store);
        app.use(router);
        app.use(VueKonva);

        // provide global access
        app.config.globalProperties.$API = API;
        app.config.globalProperties.$utils = utils;

        app.mount('#app');
    })
    .catch((error) => {
        console.error('App initialization failed:', error);
        // Still mount app but router guards will handle unauthorized access
        const app = createApp(App);
        
        app.use(store);
        app.use(router);
        app.use(VueKonva);

        // provide global access
        app.config.globalProperties.$API = API;
        app.config.globalProperties.$utils = utils;

        app.mount('#app');
        
        // Navigate to unauthorized page
        router.push({ name: 'unauthorized' });
    });